import { ToastProps } from '@galaxy-react/core';
import { EventEmitter } from 'eventemitter3';
import { IReportItem } from 'src/feature/Menu/menuModels';
import { IAsyncRequestConfig } from 'src/feature/Reports/Hooks';
import { IReportConfig } from 'src/feature/Reports/reports.config';

export type IToastProps = {
  title: React.ReactNode;
  message: React.ReactNode;
  type?: ToastProps['intent'];
  duration?: number;
  actions?: {
    label: React.ReactNode;
    onClick: () => void;
  }[];
};

export type IFileDownloadProps = {
  id: string;
  config: Partial<IAsyncRequestConfig & IReportConfig & IReportItem>;
  title: string;
};
interface Events {
  toast: (message: IToastProps) => void;
  quickSearch: (search?: string) => void;
  autoResize: () => void;
  fileDownload: (payload: IFileDownloadProps) => {};
  downloadCharts: () => void;
  printPreview: (payload: IFileDownloadProps) => {};
}
const eventEmitter = new EventEmitter<Events>();

export default eventEmitter;
